import { useMemo } from "react";

export function HtmlWidget({ data }: { data: Record<string, unknown> }) {
  const html = (data.html ?? "") as string;

  const srcdoc = useMemo(() => {
    if (!html) return "";
    // Wrap in a minimal document if it doesn't have <html> or <body>
    if (html.includes("<html") || html.includes("<!DOCTYPE")) {
      return html;
    }
    return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<style>
  body { margin: 0; padding: 12px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; background: #111827; color: #e5e7eb; }
  * { box-sizing: border-box; }
</style>
</head>
<body>${html}</body>
</html>`;
  }, [html]);

  if (!html) {
    return <div className="text-gray-500 text-sm">No HTML content</div>;
  }

  return (
    <iframe
      srcDoc={srcdoc}
      sandbox="allow-scripts"
      className="w-full h-full border-0"
      title="Widget content"
    />
  );
}
